import React from "react";
import { Box } from "@mui/material";
import { MButton, ResponsiveFormContainer } from "@app/components";
import {
  ConditionPhases,
  ConditionPhasesTypes,
} from "@app/types/samples.types";

const ConditioningForm = ({
  changePhase,
  phaseSelected,
}: {
  changePhase: (phase: ConditionPhasesTypes) => void;
  phaseSelected: ConditionPhasesTypes;
}) => {
  return (
    <ResponsiveFormContainer columns={1}>
      <Box display="flex" justifyContent="center" mt={2}>
        <MButton
          variant={
            phaseSelected === ConditionPhases.Initial ? "contained" : "outlined"
          }
          color="secondary"
          text="FASE INICIAL"
          fullWidth
          onClick={() => changePhase(ConditionPhases.Initial)}
        />
        <MButton
          variant={
            phaseSelected === ConditionPhases.Analysis
              ? "contained"
              : "outlined"
          }
          color="secondary"
          sx={{ ml: 2 }}
          text="ANÁLISIS"
          fullWidth
          onClick={() => changePhase(ConditionPhases.Analysis)}
        />
      </Box>
    </ResponsiveFormContainer>
  );
};

export default ConditioningForm;
